<form (ngSubmit)="saveParcel()" [formGroup]="form">
	<h1 mat-dialog-title>{{editingExistingParcel ? 'Edit Parcel' : 'Add Parcel'}}</h1>
	<mat-dialog-content>
		<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<mat-form-field *ngIf="!editingExistingParcel" appearance="none">
				<input matInput class="display-none"/>
				<mat-radio-group (change)="changeParcelMode($event)" [value]="parcelMode"
								 aria-label="Select an option" fxLayoutGap="10px grid">
					<mat-radio-button color="primary" value="SINGLE">
						{{'placeOrderView.createSingleParcelLabel' | translate}}
					</mat-radio-button>
					<mat-radio-button color="primary" value="MULTIPLE">
						{{'placeOrderView.createMultipleParcelsLabel' | translate}}
					</mat-radio-button>
					<mat-radio-button color="primary" value="GENERIC">
						{{'placeOrderView.createGenericParcelsLabel' | translate}}
					</mat-radio-button>
				</mat-radio-group>
			</mat-form-field>
			<mat-form-field fxFlex>
				<mat-label>{{'placeOrderView.parcelTypeLabel' | translate}}</mat-label>
				<mat-select (selectionChange)="checkDimWt()" [compareWith]="compareFn" [required]="user?.globalSettings?.requireParcelTypeForOrders"
							formControlName="type" >
					<mat-option *ngIf="!user?.globalSettings?.requireParcelTypeForOrders" [value]="null">None
					</mat-option>
					<mat-option *ngFor="let t of availableParcelTypes" [value]="t">{{t.description}}</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field *ngIf="parcelMode !== 'GENERIC' || editingExistingParcel" fxFlex>
				<mat-label>Barcode</mat-label>
				<input formControlName="reference" matInput type="text"/>
				<button (click)="createBarcode()" color="primary" mat-icon-button
						matSuffix
						matTooltip="Generate Barcode" matTooltipPosition="left" type="button">
					<mat-icon>playlist_add</mat-icon>
				</button>
				<mat-error>Barcode required</mat-error>
			</mat-form-field>
			<mat-form-field *ngIf="parcelMode === 'GENERIC' && !editingExistingParcel" fxFlex>
				<mat-label>Quantity</mat-label>
				<input appInt32Validator appOnlyNumber="true" formControlName="generateQuantity" matInput type="number"/>
				<mat-error *ngIf="form?.get('generateQuantity')?.errors?.max">
					{{'placeOrderView.maximumAllowedText' | translate}}
				</mat-error>
			</mat-form-field>
			<mat-form-field fxFlex>
				<mat-label>
					{{parcelMode === 'GENERIC' && !editingExistingParcel ? ('placeOrderView.unitsInEachContainerPlaceholder' |
					translate) : ('placeOrderView.unitsInContainerPlaceholder' | translate)}}
				</mat-label>
				<input [required]="requirePieces" appInt32Validator appOnlyNumber="true" formControlName="pieces"
					   matInput
					   type="text"/>
			</mat-form-field>
			<div fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="5px">
				<mat-form-field fxFlex="25">
					<mat-label>{{'placeOrderView.weightPlaceholder' | translate}}</mat-label>
					<input [required]="requireWeight" appInt32Validator appOnlyNumber="true" formControlName="weight"
						   matInput type="number"/>
				</mat-form-field>
				<mat-form-field fxFlex="24">
					<mat-label>{{'placeOrderView.lengthPlaceholder' | translate}}</mat-label>
					<input (change)="checkDimWt()" [required]="customer?.fieldRequiredSettings?.requireParcelDims"
						   appOnlyNumber="true" appSmallIntValidator formControlName="length"
						   matInput type="number"/>
				</mat-form-field>
				<mat-form-field fxFlex="24">
					<mat-label>{{'placeOrderView.widthPlaceholder' | translate}}</mat-label>
					<input (change)="checkDimWt()" [required]="customer?.fieldRequiredSettings?.requireParcelDims"
						   appOnlyNumber="true" appSmallIntValidator formControlName="width"
						   matInput type="number"/>
				</mat-form-field>
				<mat-form-field fxFlex="24">
					<mat-label>{{'placeOrderView.heightPlaceholder' | translate}}</mat-label>
					<input (change)="checkDimWt()" [required]="customer?.fieldRequiredSettings?.requireParcelDims"
						   appOnlyNumber="true" appSmallIntValidator formControlName="height"
						   matInput type="number"/>
				</mat-form-field>
			</div>

			<mat-form-field class="field-responsive-view">
				<mat-label>
					{{ 'placeOrderView.refrigerationTypeLabel' | translate }}
				</mat-label>
				<mat-select formControlName="refrigeration" [value]="data?.parcel?.refrigeration">
					<mat-option value="" [style.color]="'rgba(0,0,0,0.45) !important'">No Selection</mat-option>
					<mat-option *ngFor="let st of refrigerationTypes" [value]="st.description">
						{{ st?.description | removeSpecialCharacters | titlecase}}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field *ngIf="customer?.enableUserField1ForParcels">
				<mat-label>{{customer?.userField1DisplayCaption || 'User Field 1'}}</mat-label>
				<input formControlName="userField1" matInput type="text" maxlength="32"/>
				<mat-error *ngIf="form?.get('userField1')?.errors?.required">
					{{customer?.userField1DisplayCaption || 'User Field 1'}} is required
				</mat-error>
				<mat-error *ngIf="form?.get('userField1')?.errors?.maxlength">
					Maximum length is 32 characters
				</mat-error>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{'placeOrderView.commentsLabel' | translate}}</mat-label>
				<textarea formControlName="comment" mat-autosize matInput></textarea>
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-raised-button type="button" (click)="closeModal(parcelMode === 'MULTIPLE' ? 'runCalculate' : undefined)">
			Close
		</button>
		<button [color]="'accent'" mat-raised-button type="submit">
			{{parcelMode === 'GENERIC' && !editingExistingParcel ? 'Generate Parcels' : editingExistingParcel ? 'Update Parcel' : 'Create Parcel'}}
		</button>
	</mat-dialog-actions>
</form>
